enum FirstLogin {
  notFirstLogin,
  regularUserFirstLogin,
  hadrianUserFirstLogin,
}

export default FirstLogin;
